/* eslint-disable no-console */
import _ from 'underscore';
import { getItemsFromAccount, removeItemFromAccount } from '../consumer-account/storage-actions';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

// Swatch and photo image item templates
const template =
  `<div class="dealer-info">
    <p>
      <span class="heading-xxs mr-1">My Dealer:</span>
      <span class="heading-xxs mr-2"><strong>{{ businessname }}</strong></span>
      <button class="more-link view-dealer-details-btn mr-4">+ View Details</button>
      <button class="btn-secondary btn-sm savebutton">Remove</button>
    </p>
  </div>`;

const noItemsTemplate =
  `<div class="find-a-dealer">
    {{ content }}
  </div>`;

const modalTemplate =
  `<div class="modal modal-visible dealer-info-modal" id="dealer-info-modal" tabindex="0" aria-label="Dealer contact information">
    <div class="modal-overlay"></div>
    <div class="modal-panel">
      <div class="modal-header">
        <button type="button" class="close-btn" aria-label="Close Modal"></button>
      </div>
      <div class="modal-inner">
        <div class="modal-content">
          <div class="container"> 
            <div class="row">
              <div class="col-12">
                <p>
                  <span class="heading-sm"><strong>{{ businessname }}</strong></span><br />
                  <a class="phone-link" href="tel:{{ phonenumber }}">{{ phonenumber }}</a><br />
                  {{ (address && address !== '' ? address + '<br />' : '') }}
                  {{ (address2 && address2 !== '' ? address2 + '<br />' : '') }}
                  {{ city }}, {{ state }} {{ postalCode }}<br />
                  {{ (website && website !== '' ? '<a href="' + website + '" target="_blank" class="body-md">Website</a><br />' : '') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const templateVals = _.template(template);
const noItemsTemplateVals = _.template(noItemsTemplate);
const modalTemplateVals = _.template(modalTemplate);
const modal = document.querySelector('.dealer-modal-container');

let previousElementInFocus = null;
let items = [];

const props = {
  enqueuePdfUtilsData: null,
  getItemById: null,
  removePageItemById: null,
  updateSwatchbook: null,
};

const setPreviousElementInFocus = (element) => {
  previousElementInFocus = element;
  previousElementInFocus.setAttribute('aria-expanded', 'true');
};

const resetFocus = () => {
  if (previousElementInFocus) {
    previousElementInFocus.setAttribute('aria-expanded', 'false');
    previousElementInFocus.focus();
  }
};

const hasItems = () => (
  items.length !== 0
);

const update = () => {
  const { NoDealerContent } = window;
  const div = document.createElement('div');
  const selector = document.querySelector('.favorites-dealer-content');
  if (items.length === 0) {
    const compiled = noItemsTemplateVals({
      content: NoDealerContent,
    });
    div.innerHTML = compiled;
    selector.innerHTML = '';
    selector.appendChild(div.firstChild);
  }
  props.updateSwatchbook();
};

const removeModal = (event) => {
  let isModalRemoved = false;
  if (modal.firstChild !== null) {
    if (event.target.classList.contains('modal') && event.target.classList.contains('modal-visible')) {
      isModalRemoved = true;
    } else if (event.target.classList.contains('close-btn') || event.target.classList.contains('modal-overlay')) {
      isModalRemoved = true;
    }
    if (isModalRemoved) {
      modal.removeChild(modal.firstChild);
      document.removeEventListener('click', removeModal);
      resetFocus();
    }
  }
};

const addModal = (data) => {
  // Add Modal
  const div = document.createElement('div');
  const compiled = modalTemplateVals(data);
  div.innerHTML = compiled;
  modal.appendChild(div.firstChild);
  document.addEventListener('click', removeModal);
  // Set focus state
  setPreviousElementInFocus(document.activeElement);
  const modalDiv = modal.querySelector('.dealer-info-modal');
  modalDiv.focus();
};


const removeButtonHandler = () => {
  const { assetId } = items[0];
  removeItemFromAccount('location', assetId, () => {
    props.removePageItemById(items, assetId);
    const selector = document.querySelector('.favorites-dealer-content');
    selector.querySelector('.savebutton').removeEventListener('click', removeButtonHandler);
    selector.removeChild(selector.firstChild);
    update();
  });
};

const addEventHandlers = () => {
  const viewDetailsBtn = document.querySelector('.view-dealer-details-btn');
  if (viewDetailsBtn) {
    viewDetailsBtn.addEventListener('click', () => {
      addModal(items[0]);
    });
  }
};

const onLoaded = (data) => {
  // console.log(data);
  const { dealer } = data;
  if (dealer !== null) {
    items = [{
      address: dealer.address,
      address2: dealer.address2,
      assetId: dealer['dealer-id'],
      businessname: dealer['location-name'],
      city: dealer.city,
      phonenumber: dealer['business-phone'],
      postalCode: dealer['postal-code'],
      state: dealer.state,
      website: dealer.website,
      type: 'location', // for pdfutils
    }];
    // Display saved content
    const selector = document.querySelector('.favorites-dealer-content');
    const div = document.createElement('div');
    const compiled = templateVals(items[0]);
    selector.innerHTML = '';
    div.innerHTML = compiled;
    selector.appendChild(div.firstChild);
    selector.querySelector('.savebutton').addEventListener('click', removeButtonHandler);
  }
  props.enqueuePdfUtilsData(items);
  addEventHandlers();
  update();
};

const init = (options) => {
  const {
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  } = options;
  props.enqueuePdfUtilsData = enqueuePdfUtilsData;
  props.getItemById = getItemById;
  props.removePageItemById = removePageItemById;
  props.updateSwatchbook = updateSwatchbook;
  getItemsFromAccount('location', onLoaded);
};

export {
  hasItems,
  init,
  onLoaded,
};
/* eslint-enable no-console */
